var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardDinersClub(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">", _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#d3d3d3",
    strokeMiterlimit: 10,
    fill: "#0079be"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 19,
    rx: 1.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.177 9.9a6.118 6.118 0 00-6.258-6.05H13.1A5.91 5.91 0 007.064 9.9a6 6 0 006.036 5.945h2.816A6.226 6.226 0 0022.177 9.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.121 4.354A5.491 5.491 0 1018.6 9.845a5.485 5.485 0 00-5.479-5.491z",
    fill: "#0079be"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.658 9.835a3.486 3.486 0 012.229-3.248v6.5a3.484 3.484 0 01-2.229-3.252zm4.714 3.249v-6.5a3.481 3.481 0 010 6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardDinersClub);
export default __webpack_public_path__ + "static/media/CreditCard_DinersClub.a86cea393d41f18e2601aa5f14b25c24.svg";
export { ForwardRef as ReactComponent };